var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
const getAllUsers = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Users/get-all-users", query);
    return response;
});
const getActiveUsers = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Users/active-users-dropdown");
    return response;
});
const createNewUser = (userData) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Users/create-new-user", userData);
    return response;
});
const updateUser = (userData) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put("Users/update-user", userData);
    return response;
});
const deleteUser = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.delete(`Users/delete-user/${id}`);
    return response;
});
const toggleUserStatus = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.patch("Users/toggle-user-status", data);
    return response;
});
const getUserEmail = (userId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("AccessPoints/get-user-email", { params: { userId } });
    return response;
});
const getActiveUsersEmailDropdown = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get("Users/active-users-email-dropdown");
    return response;
});
const getUserProfile = (userId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`Users/profile/${userId}`);
    return response;
});
const startImpersonation = (targetUserId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Users/start-impersonation", { targetUserId });
    return response;
});
const removeAccessPointFromUser = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("Users/remove-access-point", request);
    return response;
});
export const usersApi = {
    getAllUsers,
    getActiveUsers,
    createNewUser,
    updateUser,
    deleteUser,
    toggleUserStatus,
    getUserEmail,
    getActiveUsersEmailDropdown,
    getUserProfile,
    startImpersonation,
    removeAccessPointFromUser,
};
